export default function Hero() {
  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-16 md:pt-[72px] overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/30"></div>
      <div className="absolute top-20 right-0 w-[500px] h-[500px] bg-primary-100/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-10 left-10 w-[350px] h-[350px] bg-accent-100/15 rounded-full blur-3xl"></div>

      <div className="relative w-full px-4 md:px-6 py-10 md:py-16 max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 bg-primary-100/80 text-primary-700 text-sm font-medium rounded-full whitespace-nowrap">
              <i className="ri-fire-line"></i>
              每日更新 · 实时追踪
            </span>

            <h1 className="mt-5 text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight">
              911爆料网
              <span className="block text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-primary-600 mt-2">
                聚焦热点爆料的吃瓜黑料平台
              </span>
            </h1>

            <p className="mt-3 text-base md:text-lg text-primary-500 font-heading">
              一手爆料，实时吃瓜，不放过每一个热点
            </p>

            <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto lg:mx-0">
              911爆料网是国内领先的吃瓜黑料资讯聚合平台，每日追踪娱乐圈、社会热点、网红八卦等各类爆料事件。
              我们7×24小时不间断更新，覆盖30+话题领域，为用户提供最新、最全、最热的一手爆料内容。
              无论你是资深吃瓜群众还是偶尔围观的路人，这里都是你获取第一手八卦资讯的最佳入口。
            </p>

            <div className="mt-8 flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6">
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-8 h-8 flex items-center justify-center bg-accent-100 rounded-lg">
                  <i className="ri-flashlight-line text-accent-600 text-base"></i>
                </span>
                <span className="whitespace-nowrap">日均更新 <strong className="text-foreground-900">50+</strong> 条爆料</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-8 h-8 flex items-center justify-center bg-primary-100 rounded-lg">
                  <i className="ri-global-line text-primary-600 text-base"></i>
                </span>
                <span className="whitespace-nowrap">覆盖 <strong className="text-foreground-900">30+</strong> 话题领域</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-8 h-8 flex items-center justify-center bg-secondary-100 rounded-lg">
                  <i className="ri-time-line text-secondary-600 text-base"></i>
                </span>
                <span className="whitespace-nowrap"><strong className="text-foreground-900">7×24</strong> 小时实时追踪</span>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <a
                href="#updates"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap text-sm md:text-base"
              >
                <i className="ri-arrow-right-circle-line text-lg"></i>
                立即吃瓜
              </a>
              <a
                href="#contact"
                className="inline-flex items-center gap-2 px-8 py-3.5 border-2 border-primary-200 text-primary-600 font-medium rounded-lg hover:bg-primary-50 transition-colors duration-200 whitespace-nowrap text-sm md:text-base"
              >
                <i className="ri-send-plane-line text-lg"></i>
                投稿爆料
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Dynamic%20abstract%20news%20media%20visual%20with%20warm%20red%20and%20amber%20gradient%20tones%2C%20layered%20geometric%20shapes%20representing%20breaking%20news%20and%20information%20flow%2C%20modern%20editorial%20design%20with%20bold%20contrast%2C%20dramatic%20lighting%20on%20abstract%20forms%2C%20warm%20dark%20background%20with%20vibrant%20red%20and%20gold%20accents%2C%20clean%20minimalist%20composition%20with%20strong%20visual%20impact&width=960&height=720&seq=hero-main-2026&orientation=landscape"
                alt="911爆料网 - 聚焦热点爆料的吃瓜黑料平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}